// @core/api/endpoints/search/get_search_index.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SearchIndexResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Get search index
 * Retrieves a search index configuration by its unique identifier.
 */
export async function GetSearchIndex(
  index_id: string,
  options?: RequestOptions
): Promise<SearchIndexResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/search/indexes/:index_id`;
  requestPath = requestPath.replace(':index_id', encodeURIComponent(index_id));
  const requestOptions = options;
  return client.get<SearchIndexResponse>(requestPath, { ...requestOptions });
}
